export default "__VITE_ASSET__DKyMM$Ab__"